var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import NumberFormat from 'react-number-format';
import { formatPhoneNumber } from '@common/utils/format';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { CheckBox, Form } from 'oned';
import { AvailAbilityStep, ContactKey, SummaryScreenSubTitle, SummaryScreenTitle } from '@common/enums/availability';
import AvailabilitySelected from './availabilitySelected';
var FormItem = Form.FormItem;
var SummaryScreen = inject(AvailabilityBusiness)(observer(function (props) {
    var availabilityStep = props.availabilityStep, setAvailabilityParams = props.setAvailabilityParams, form = props.form, contactPhone = props.contactPhone, contactFlagofPhonesForTextMessagingApproved = props.contactFlagofPhonesForTextMessagingApproved, contactIsOriginApproved = props.contactIsOriginApproved, contactOriginPhone = props.contactOriginPhone, updateSummaryPhoneData = props.updateSummaryPhoneData;
    var Title = function () {
        if (availabilityStep === AvailAbilityStep.UnavailabilitySummary) {
            return SummaryScreenTitle.UnavailableTimesTitle;
        }
        if (availabilityStep === AvailAbilityStep.AvailabilitySummary) {
            return SummaryScreenTitle.AvailableTimesTitle;
        }
    };
    var SubTitle = function () {
        if (availabilityStep === AvailAbilityStep.UnavailabilitySummary) {
            return SummaryScreenSubTitle.UnavailableTimesSubTitle;
        }
        if (availabilityStep === AvailAbilityStep.AvailabilitySummary) {
            return SummaryScreenSubTitle.AvailableTimesSubTitle;
        }
    };
    var jumpStep = function () {
        if (availabilityStep === AvailAbilityStep.UnavailabilitySummary) {
            setAvailabilityParams('availabilityStep', AvailAbilityStep.FlexibleTime);
        }
        if (availabilityStep === AvailAbilityStep.AvailabilitySummary) {
            setAvailabilityParams('availabilityStep', AvailAbilityStep.LimitedTime);
        }
    };
    var getFieldProps = form.getFieldProps, getFieldError = form.getFieldError;
    var getError = function (field) {
        var error = getFieldError(field);
        return error ? error.join(",") : "";
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center' },
            React.createElement("h2", { className: 'mb-0' },
                React.createElement("b", { className: 'title' }, Title()),
                " "),
            React.createElement("a", { href: "javascript:void(0)", className: "d-inline-flex align-items-center ml-2", onClick: function () { return jumpStep(); } },
                React.createElement("span", { style: { fontSize: "16px" } }, " Edit"),
                React.createElement("i", { className: 'sc-icon-pencil iconfont icon-edit text-primary f20 line-height-default' }))),
        React.createElement("div", { className: 'pt-0 ft-16' }, SubTitle()),
        React.createElement("div", { className: 'd-flex row no-gutters' },
            React.createElement("div", { className: 'col-md-7 col-xs-12' },
                React.createElement("div", { className: 'availability-selected-item' },
                    React.createElement(AvailabilitySelected, { showSlot: false })))),
        React.createElement("h2", { className: 'pt-5' },
            React.createElement("b", { className: 'title' }, "Confirm phone number"),
            " "),
        React.createElement("div", { className: 'pt-0 ft-16' }, "Please confirm your phone number so the specialist can contact you to schedule if needed."),
        React.createElement("div", { className: 'pt-4' },
            React.createElement("div", null,
                React.createElement("b", { className: 'title f18' }, "Primary phone #")),
            React.createElement("div", { className: 'pt-2' },
                React.createElement(FormItem, { error: getError('PhoneNumber') },
                    React.createElement(NumberFormat, __assign({ format: "(###) ###-####", className: "dsm-form-control", placeholder: "Phone number...", defaultValue: contactPhone, value: contactPhone, onValueChange: function (values) {
                            var formattedValue = values.formattedValue, value = values.value;
                            form.setFieldsValue({
                                PhoneNumber: value
                            });
                            updateSummaryPhoneData(value, ContactKey.Phone);
                        } }, getFieldProps("PhoneNumber", {
                        initialValue: formatPhoneNumber(contactPhone),
                        validateTrigger: 'onBlur',
                        rules: [
                            {
                                pattern: /^\(\d{3}\)\s\d{3}-\d{4}$/,
                                message: 'The phone format is invalid.'
                            }
                        ]
                    }))))),
            React.createElement("div", { className: 'pt-3' },
                React.createElement(CheckBox, { name: "PhoneOptInForMessages", checked: contactFlagofPhonesForTextMessagingApproved, labelName: 'Opt-in for text messages', labelClassName: 'dsm-control-label f16', disabled: contactIsOriginApproved && contactPhone === contactOriginPhone, onChange: function (value) {
                        updateSummaryPhoneData(value, ContactKey.FlagofPhonesForTextMessagingApproved);
                    } }))));
}));
export default SummaryScreen;
